import React, { useContext, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';

import { ArnContext, FormContext } from 'contexts';
import IdentityFileUpload from './IdentityFileUpload';
import { ArnApplicationDvsMethodFormData, IPersonalDetails } from 'types/forms/arnApplicationTypes';
import {
  ApplicationName,
  FormNavigation
} from 'components/CASAForm';
import { AuDirectionLink } from 'components/DTA';
import { IFormAlertType } from 'types/forms/formTypes';
import {
  getIdentityDocumentTitleAndDataModel
} from 'helpers/arnApplicationHelper';
import SortedTable from 'components/Portal/SortedTable';

const UploadFileForManualIdentification: React.FC = () => {
  const { handleBack } = useContext(FormContext);
  const { setPreviousStep, previousStep } = useContext(ArnContext);
  const { values, setFieldValue, validateForm, getFieldMeta } = useFormikContext<ArnApplicationDvsMethodFormData>();
  const { setFormAlert, openStepById, setOnChangeValidation } = useContext(FormContext);
  const [selectedPOIDocumentSummary, setSelectedPOIDocumentSummary] = useState<Array<any>>([]);
  const identity = getIdentityDocumentTitleAndDataModel(values?.identityType);

  useEffect(() => {
    const selectedDocuments = Array<any>();
    values.manualPOIDocuments.primaryDocuments70Points?.map(item => {
      selectedDocuments.push({'poiDocumentType': item, 'poiDocumentPoint': 70});
    });
    values.manualPOIDocuments.primaryDocuments40Points?.map(item => {
      selectedDocuments.push({'poiDocumentType': item, 'poiDocumentPoint': 40});
    });
    values.manualPOIDocuments.secondaryDocuments40Points?.map(item => {
      selectedDocuments.push({'poiDocumentType': item, 'poiDocumentPoint': 40});
    });
    values.manualPOIDocuments.secondaryDocuments25Points?.map(item => {
      selectedDocuments.push({'poiDocumentType': item, 'poiDocumentPoint': 25});
    });
    setSelectedPOIDocumentSummary(selectedDocuments);
  }, [values.manualPOIDocuments]);

  const showSelectedPOIDocumentSummary = () => {
    const caption = '';
    const selectedPOIDocumentSummaryCols = [
      {
        'label': 'Identity documents',
        'property': 'poiDocumentType',
        'visible': true,
        'command': null,
        'commandLink': null,
        'type': 'string',
        'width': '50%'
      },
      {
        'label': 'Points',
        'property': 'poiDocumentPoint',
        'visible': true,
        'command': null,
        'commandLink': null,
        'type': 'string',
        'width': '50%'
      }
    ];

    return (
      <div>
        <SortedTable
          data={selectedPOIDocumentSummary}
          cols={selectedPOIDocumentSummaryCols}
          caption={caption}
          ignoreSortByColumn = {true}
        />
      </div>
    );
  };

  const handleBackAction = () => {
    setFieldValue('manualPOIDocuments.isManualUpload', false);
    if (previousStep) {
      openStepById(previousStep);
      return;
    }
    handleBack();
  };

  const handleNext = async () => {
    const validationErrors = await validateForm();
    // check if no file is selected
    if (values.manualPOIDocuments.filename && values.manualPOIDocuments.filename.length == 0) {
      const alert: IFormAlertType = {
        as: 'error',
        title: 'There was a problem with the form',
        message: 'Please upload a document before proceeding.'
      };

      setFormAlert(alert);
      window.scrollTo(0, 0);
      return;
    }
    // Proceed to DeclarationAndSubmit if there aren't any errors
    if (!validationErrors || isEmpty(validationErrors)) {

      setFormAlert(null);
      setOnChangeValidation(false);

      const nextStepsId = 'DeclarationAndSubmit';
      const previousStepId = 'UploadFileForManualIdentification';
      setPreviousStep(previousStepId);
      openStepById(nextStepsId);
      setOnChangeValidation(false);
      return;
    }

    const alert: IFormAlertType = {
      as: 'error',
      title: 'There was a problem with the form',
      message: 'Please check the form below and try again'
    };

    setFormAlert(alert);
    setOnChangeValidation(true);
  };

  return (
    <>
      <ApplicationName name='Manual verification' />
      <AuDirectionLink onClick={handleBackAction} text="Back" direction="left" />
      <h3>Upload your identity documents</h3>
      <p>
            All points of identification must be certified. To see who can certify documents read our <a href="https://www.casa.gov.au/licences-and-certificates/aviation-reference-numbers/certifying-your-identity-documents" target="_blank" rel='noreferrer'>certifying your identity documents page.</a>
      </p>
      {showSelectedPOIDocumentSummary()}
      <IdentityFileUpload/>
      <FormNavigation nextButtonText='Next' hidePrevious onNextAction={handleNext} showSaveAndExit={false} />
    </>
  );
};

export default UploadFileForManualIdentification;